import { render, staticRenderFns } from "./RefsAttachmentRequest.vue?vue&type=template&id=3f19517d&scoped=true&"
import script from "./RefsAttachmentRequest.vue?vue&type=script&lang=ts&"
export * from "./RefsAttachmentRequest.vue?vue&type=script&lang=ts&"
import style0 from "./RefsAttachmentRequest.vue?vue&type=style&index=0&id=3f19517d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f19517d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSpacer})
